import { VCard } from 'vuetify/lib/components/VCard';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{staticClass:"container"},[_c(VTabs,{key:_vm.index,attrs:{"background-color":"#fff","show-arrows":"","tag":"li","slider-color":_vm.color,"slider-size":_vm.size}},_vm._l((_vm.letterPagination),function(item,id){return _c(VTab,{key:id,staticClass:"letter-tab",attrs:{"active-class":"letter-tab--active"},on:{"click":function($event){_vm.$emit('updateLetter', item.letter.toLowerCase())}}},[_vm._v(" "+_vm._s(item.letter)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }